import React from 'react';
import { Typography, Box } from '@mui/material';
import { RateReview as ReviewIcon } from '@mui/icons-material';
import ReviewListItem from './ReviewListItem';
import { useLanguage } from '../contexts/LanguageContext';

const ReviewList = ({ reviews, showDelete = false, currentUserId = null, onReviewDeleted = null }) => {
  const { t } = useLanguage();

  if (!reviews || reviews.length === 0) {
    return (
      <Box sx={{ 
        mt: 2, 
        p: 4, 
        border: '2px dashed', 
        borderColor: 'grey.300',
        borderRadius: 2,
        textAlign: 'center',
        bgcolor: 'grey.50'
      }}>
        <ReviewIcon sx={{ fontSize: 48, color: 'grey.400', mb: 2 }} />
        <Typography variant="h6" color="text.secondary" gutterBottom>
          {t('No reviews yet', 'لا توجد تقييمات بعد')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('Be the first to add one!', 'كن أول من يضيف واحدة!')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      {reviews.map((review) => (
        <ReviewListItem 
          key={review.id} 
          review={review} 
          showDelete={showDelete}
          currentUserId={currentUserId}
          onReviewDeleted={onReviewDeleted}
        />
      ))}
    </Box>
  );
};

export default ReviewList; 